
export default {
    getUserInfo: {
        config: {
            url: 'api/getuserinfo',
            method: 'GET'
        }
    },
    getAreaLinkage: {
        config: {
            url: 'area/linkage',
            method: 'GET',
            headers: {
                tenant: '0000',
            },
        }
    },
    getTree: {
        config: {
            url: 'area/tree',
            method: 'GET',
            headers: {
                tenant: '0000',
            },
        }
    }
}